var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0426 30.6737C10.4748 31.3276 9.57286 31.3053 9.02796 30.6239L2.3976 22.3333C1.86847 21.6717 1.86847 20.627 2.3976 19.9654L9.02796 11.6747C9.57286 10.9935 10.4748 10.9712 11.0426 11.625C11.6103 12.2789 11.629 13.3614 11.0841 14.0427L6.76857 19.439L20.0067 19.439C20.7936 19.439 21.4316 20.2046 21.4316 21.1489C21.4316 22.0933 20.7936 22.8588 20.0067 22.8588L6.76781 22.8588L11.0841 28.256C11.629 28.9373 11.6103 30.0198 11.0426 30.6737Z",
    fill: "#3733BF",
    stroke: "#3733BF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.25 39.3888C35.25 40.3332 34.612 41.0988 33.8251 41.0988L15.8622 41.0988C15.075 41.0988 14.4372 40.3332 14.4372 39.3888L14.4372 32.5491C14.4372 31.6047 14.4372 29.6391 16.5 29.6391C18.2871 29.6391 18.2871 31.6047 18.2871 32.5491L18.2871 36.4789L31.4001 36.4789L31.4001 5.82015L18.2871 5.82015L18.2871 9.74995C18.2871 10.6943 17.9249 12.6003 16.5 12.6003C14.4372 12.6003 14.4372 10.6943 14.4372 9.74995L14.4372 2.91021C14.4372 1.96587 15.0751 1.20027 15.8622 1.20027L33.8251 1.20028C34.612 1.20028 35.25 1.96587 35.25 2.91021L35.25 39.3888Z",
    fill: "#3733BF",
    stroke: "#3733BF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/logouticon.77f974b7a80587365d1a5f1e6e23fded.svg";
export { ForwardRef as ReactComponent };